import styled from '@emotion/styled'

export {
  DeleteButton,
  ActionCard,
  FieldGroup,
  FieldLabel,
  OutlineButton,
  PrimaryButton
} from '../styles'

export const SidePanel = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
  height: fit-content;
  max-width: 360px;
`

export const SidePanelTitle = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #4a4a68;
  margin-bottom: 8px;
`

export const SidePanelList = styled.ol`
  margin: 0;
  padding-left: 20px;
`

export const SidePanelItem = styled.li`
  font-size: 14px;
  font-weight: 400;
  color: #4a4a68;
  line-height: 1.6;
`

export const OpenShipdayButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 8px 16px;
  border: 1px solid #4a4a68;
  border-radius: 4px;
  color: #4a4a68;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 0.04em;

  &:hover,
  &:focus {
    color: #4a4a68;
    border-color: #4a4a68;
    text-decoration: none;
  }
`
